import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { Response } from '@angular/http';
import { Subscription } from 'rxjs/Rx';
import { EventManager, AlertService } from 'ng-jhipster';

import { LicenceSchool } from './licence-school.model';
import { LicenceSchoolService } from './licence-school.service';
import { Principal } from '../../shared';
import {UtilsService} from '../../shared/utils/utils.service';
import {CampaignService} from '../campaign/campaign.service';

@Component({
    selector: 'jhi-licence-school',
    templateUrl: './licence-school.component.html'
})
export class LicenceSchoolComponent implements OnInit, OnDestroy {
    licenceSchools: LicenceSchool[];
    currentAccount: any;
    eventSubscriber: Subscription;
    @ViewChild('dtLicenceSchool') dtLicenceSchool;
    multiSortMetaDtLicenceSchools: any[];

    private subscription: Subscription = new Subscription();

    constructor(
        private licenceSchoolService: LicenceSchoolService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private principal: Principal,
        public utilsService: UtilsService,
        public campaignService: CampaignService
    ) {}

    loadAll() {
        this.subscription.add(this.licenceSchoolService.query().subscribe(
            (res: Response) => {
                this.licenceSchools = res.json();
            },
            (res: Response) => this.onError(res.json())
        ));
    }
    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInLicenceSchools();
        this.loadAll();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
        this.subscription.unsubscribe();
    }

    trackId (index: number, item: LicenceSchool) {
        return item.id;
    }



    registerChangeInLicenceSchools() {
        this.eventSubscriber = this.eventManager.subscribe('licenceSchoolListModification', (response) => this.loadAll());
    }


    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/licence-school/licence-school.component.ts